import { AutoCompleteItem } from "@surya-digital/leo-reactjs-material-ui";

export const getOptionsWithSelectedAutoCompleteValues = (
  options: AutoCompleteItem[],
  selectedValues: AutoCompleteItem[],
): AutoCompleteItem[] => {
  const selectedOptionIds = new Set(options.map((option) => option.id));
  return [
    ...options,
    ...selectedValues.filter((option) => !selectedOptionIds.has(option.id)),
  ];
};
